import type { VisibilityMap } from "../../../../../components/Questionnaire/validation/form/types";
import {
  isAddressGroup,
  isShadowGroup,
  type Answers,
  type QuestionnaireState,
  type UpdateAnswerPayload,
} from "../../../types";
import { applyYesNoToggleUpdates } from "./yesNoToggle/applyYesNoToggleUpdates";
import { applyMultiselectUpdates } from "./multiselect/applyMultiselectUpdates";
import { applyPersonalisedCoverUpdates } from "./personalisedCoverGroup/applyPersonalisedCoverUpdates";
import { applyAddressLookupUpdates } from "./addressLookup/applyAddressLookupUpdates";

export const applyGroupAnswerAndVisibility = (
  state: QuestionnaireState,
  payload: UpdateAnswerPayload,
  serverVisibleByName: Record<string, boolean>,
): { answers: Answers; visibility: VisibilityMap } => {
  const { groups, answers, visibility } = state;
  const group = groups[payload.name];

  if (!group || group.names?.length === 0) {
    return { answers, visibility };
  }

  if (group.kind === "group") {
    return applyYesNoToggleUpdates({
      groupNames: group.names,
      groups,
      answers,
      visibility,
      serverVisibleByName,
      value: payload.value,
    });
  } else if (group.kind === "personalised_cover") {
    return applyPersonalisedCoverUpdates({
      groupNames: group.names,
      answers,
      visibility,
      serverVisibleByName,
      state,
      questionName: payload.name,
      value: payload.value,
    });
  } else if (isShadowGroup(group)) {
    const result = applyMultiselectUpdates({
      shadowGroup: group,
      answers,
      value: payload.value,
    });
    // Shadow groups do not alter visibility
    return { answers: result.answers, visibility };
  } else if (isAddressGroup(group)) {
    return applyAddressLookupUpdates({
      groupNames: group.names,
      answers,
      visibility,
      serverVisibleByName,
      state,
    });
  }

  return { answers, visibility };
};
